import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { freeBusyCache, FreeBusyType } from 'owa-freebusy-cache';
import { lazyGetRoomFreeBusy } from 'owa-room-selection';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import FreeBusyBadgeBase from './FreeBusyBadgeBase';

export interface LocationFreeBusyBadgeProps {
    event: CalendarEvent;
    emailAddress: string;
}

const LocationFreeBusyBadge = observer(function LocationFreeBusyBadge(
    props: LocationFreeBusyBadgeProps
) {
    const { event, emailAddress } = props;
    const [locationFbStatus, setLocationFbStatus] = React.useState(FreeBusyType.NoData);

    lazyGetRoomFreeBusy.import().then(getRoomFreeBusy => {
        const calendarTime = {
            Start: event.Start,
            End: event.End,
            IsAllDayEvent: event.IsAllDayEvent,
            Recurrence: event.Recurrence,
            RequiredAttendees: event.RequiredAttendees,
            OptionalAttendees: event.OptionalAttendees,
        };

        const newLocationFbStatus = getRoomFreeBusy(emailAddress, freeBusyCache, calendarTime)
            .freeBusyState;
        if (newLocationFbStatus != locationFbStatus) {
            setLocationFbStatus(newLocationFbStatus);
        }
    });

    return <FreeBusyBadgeBase freeBusyType={locationFbStatus} isResource={true} />;
});
export default LocationFreeBusyBadge;
